import { Component, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core'
import { BaseComponent } from '../../components/base.component'
import { SessionActions } from '../../actions/session-actions'
import { environment } from '../../environments/environment'
import { externalRoute } from './external-routes'
import { Location } from '@angular/common'
import { Account, User, Data, NavBarQueries, ExtraPurchase, Writer } from './nav-bar.queries'
import { Router, ActivatedRoute } from '@angular/router'
import { MatSidenav } from '@angular/material/sidenav'
import { get, flatten } from 'lodash-es'
import { QueryRef } from 'apollo-angular'
import moment from 'moment'
import { WriterProfileSummaryMutations } from '../writer-dashboard/writer-profile-summary/writer-profile-summary.mutations'
import { EditspaceService } from 'src/services/editspace.service'

@Component({
  selector: 'nav-bar',
  template: `
    <nav class="navbar navbar-expand-lg navbar-dark bg-header-bg">
      <button *ngIf="showMobileSidebarButton" class="btn btn-outline-tertiary" (click)="sidenav?.toggle()">
        <i class="fas fa-ellipsis-v text-white"></i>
      </button>
      <home-link [logo]="true" [currentUser]="currentUser"></home-link>
      <button class="navbar-toggler" type="button" aria-controls='navvy-heading' aria-expanded='false' aria-label='Toggle Navigation' (click)="navbarCollapsed = !navbarCollapsed">
        <span class="navbar-toggler-custom fas fa-bars"></span>
      </button>
      <div id="navvy-heading" class="collapse navbar-collapse" [collapse]="navbarCollapsed">
        <ul *ngIf="!isEditspace" class="navbar-nav mr-auto">
          <li class="nav-item" *ngIf="isWriter && shouldShowHomeLink">
            <home-link [text]="'Home'" [currentUser]="currentUser"></home-link>
          </li>
          <li *ngIf="canReadJobs" class="nav-item dropdown" dropdown
            [class.active]="matchesPaths([linkTo('search_path'), linkTo('high_priority_keywords_path'), linkTo('deadline_keywords_path'), linkTo('most_urgent_customers_path')])">
            <a class="nav-link dropdown-toggle" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle>
              Jobs
              <span class="badge badge-pill badge-primary ml-1" *ngIf="writer.assignmentCount > 0">
                {{ writer.assignmentCount }}
              </span>
              <span class="caret"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
              <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/writer_dashboard', 'search']">
                <i class="fas fa-search tiny-right-buffer"></i>
                Search Jobs
              </a>
              <a class="dropdown-item" [class.active]="matchesPath(linkTo('most_wanted_keywords_path'))"  href="{{ linkTo('most_wanted_keywords_path') }}">
                <i class="fas fa-hand-point-right tiny-right-buffer"></i>
                Most Wanted
              </a>
              <a class="dropdown-item" [class.active]="matchesPath(linkTo('writer_pool_keywords_path'))"  href="{{ linkTo('writer_pool_keywords_path') }}">
                <i class="fas fa-hand-holding-heart tiny-right-buffer"></i>
                Picked for You
              </a>
              <a class="dropdown-item" [class.active]="matchesPath(linkTo('deadline_keywords_path'))" href="{{ linkTo('deadline_keywords_path') }}">
                <i class="far fa-clock tiny-right-buffer"></i>
                Deadlines
              </a>
              <a class="dropdown-item" [class.active]="matchesPath(linkTo('assigned_keywords_path'))" href="{{ linkTo('assigned_keywords_path') }}">
                <i class="fas fa-user-check tiny-right-buffer"></i>
                Assignments
                <span class="badge badge-pill badge-primary ml-1" *ngIf="writer.assignmentCount > 0">
                  {{ writer.assignmentCount }}
                </span>
              </a>
              <div class="dropdown-divider"></div>
              <div class="dropdown-header">Saved Searches</div>
              <a *ngFor="let search of writer?.customerSearches" class="dropdown-item" routerLink="." (click)="navigateToUrl(search.url)">
                {{ search.name }}
              </a>
              <a class="dropdown-item" *ngIf="writer?.customerSearches.length === 0">
                None saved
              </a>
            </div>
          </li>
          <li *ngIf="canCreateTopics" class="nav-item" [class.active]="matchesPath('/writer_dashboard/topic_proposing')">
            <a class="nav-link" [routerLink]="['/', 'writer_dashboard', 'topic_proposing']">
              Topics
              <span class="badge badge-pill badge-primary ml-1" *ngIf="writer.proposedKeywordsNotificationsCount > 0">
                {{ writer.proposedKeywordsNotificationsCount }}
              </span>
              <span class="badge badge-pill badge-primary ml-1" *ngIf="writer.proposedKeywordsNotificationsCount === 0 && writer.noKeywordsAlert" title="Your customers need topics">
                &#x270e;
              </span>
            </a>
          </li>
          <li class="nav-item" *ngIf="canReadInvoices"><a id="writer-invoices" class="nav-link" href="{{ linkTo('invoices_path') }}">Invoices</a></li>
          <li class="nav-item" *ngIf="isWriter && canReadDiscussion">
            <a class="nav-link" href="{{ linkTo('forum_path') }}">
              Forum
              <span class="badge badge-pill badge-primary ml-1" *ngIf="writer.forumNotificationsCount > 0">
                {{ writer.forumNotificationsCount }}
              </span>
            </a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li *ngIf="(currentUser?.canChatHelp || currentUser?.canPhoneHelp) && !isWhiteLabelUserInEditspace()" class="nav-item dropdown" dropdown>
            <a id="customer-help" class="nav-link dropdown-toggle" dropdownToggle>
              Help
              <span class="caret"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu>
              <a id="help-center" *ngIf="currentUser?.canIndexHelpPage" class="dropdown-item" href="https://help.verblio.com" target="_blank">
                <i class="fas fa-question mr-2"></i>Help Center
              </a>
              <a id="help-live-chat" *ngIf="currentUser?.canChatHelp" class="dropdown-item" href="javascript: window.Intercom('show');">
                <i class="fas fa-comments mr-2"></i>Live Chat
              </a>
            </div>
          </li>
          <li *ngIf="!isWriter && currentUser?.canIndexHelpPage && !isWhiteLabelUserInEditspace() && !(currentUser?.canChatHelp || currentUser?.canPhoneHelp)" class="nav-item">
            <a id="help-center" class="nav-link" href="https://help.verblio.com">Help</a>
          </li>
          <li class="nav-item" *ngIf="isAgencySignup && !isWhiteLabelUserInEditspace()">
            <a class="nav-link no-decoration ap-open" href="javascript: window.Intercom('show');">
              <span class="text-white bigger-than-normal-text">Need help?</span>
              <strong class="pl-2 underline">Chat with us</strong>
            </a>
          </li>
          <li *ngIf="isWriter && currentUser?.canIndexHelpPage" class="nav-item"><a id="writer-help" class="nav-link" href="{{ linkTo('help_path') }}" target="_blank">Help</a></li>
          <li *ngIf="isWriter && !isWhiteLabelUserInEditspace() && !isWriterFrozen" class="nav-item"><a id="writer-contact" class="nav-link" href="{{ linkTo('contact_link') }}">Contact</a></li>
          <li *ngIf="showVerticalDivider && !isWriterFrozen" class="divider-vertical"></li>
          <li class="nav-item" *ngIf="!showDropdownMenu">
            <a class="nav-link" href="javascript:void(0)" (click)="signOut()">
              <i class="fas fa-sign-out-alt mr-2"></i>
              Sign out
            </a>
          </li>
          <li *ngIf="currentUser && showDropdownMenu && !isWhiteLabelUserInEditspace()" class="nav-item dropdown" dropdown>
            <a id="email-toggle" class="nav-link dropdown-toggle" dropdownToggle>
              {{ currentUser.email }}
              <span class="caret"></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu>
              <a *ngIf="currentUser?.canUpdateUser" id="user-preferences" class="dropdown-item" href="{{ linkTo('edit_user_registration_path') }}">
                <i class="fas fa-user tiny-right-buffer"></i>
                User Preferences
              </a>
              <a *ngIf="currentUser?.canEditUserEmailPreferences" id="email-preferences" class="dropdown-item" href="{{ linkTo('edit_email_preferences_user_path', currentUser.id) }}">
                <i class="far fa-envelope tiny-right-buffer"></i>
                Email Preferences
              </a>
              <a *ngIf="currentUser?.writer?.canUpdate" id="account-preferences" class="dropdown-item" href="{{ linkTo('edit_writer_path', writer.id) }}">
                <i class="fas fa-cog tiny-right-buffer"></i>
                Account Preferences
              </a>
              <a *ngIf="isWriter && canEditProfile" id="edit-profile" class="dropdown-item" href="{{ linkTo('edit_writer_profile_path', writer.id) }}">
                <i class="far fa-id-card tiny-right-buffer"></i>
                Profile Info
              </a>
              <a *ngIf="isWriter" id="view-w9" class="dropdown-item" href="{{ writer.hasW9Record ? linkTo('edit_writer_w9_record_path', writer.id) : linkTo('new_writer_w9_record_path', writer.id) }}">
                <i class="far fa-file-alt tiny-right-buffer"></i>
                W-9
              </a>
              <a *ngIf="isWriter && currentUser?.canCreateWriterGoal" id="edit-goals" class="dropdown-item" [routerLink]="['/writer_dashboard/goals']">
                <i class="fas fa-flag tiny-right-buffer"></i>
                Goals
              </a>
              <ng-template [ngIf]="!isAgencySignup">
                <div
                  *ngIf="
                    currentUser?.canShowBillingAccount ||
                    currentUser?.canIndexAccountInvoices ||
                    currentUser?.canUpdateMembers ||
                    showWhiteLabel ||
                    currentUser?.canResetDemo
                  "
                  class="dropdown-header">
                  Account
                </div>
                <a *ngIf="currentUser?.canShowBillingAccount" [routerLink]="['/dashboard', 'billing_info', 'edit']" class="dropdown-item">Payment Info</a>
                <a *ngIf="currentUser?.canIndexAccountInvoices" href="/account_invoices" class="dropdown-item">Invoices</a>
                <a *ngIf="currentUser?.canUpdateMembers" class="dropdown-item" href="/members/new">Manage Members</a>
                <a *ngIf="currentUser?.canViewWhiteLabelProfile" class="dropdown-item" [routerLink]="'/dashboard/white_label_profile'">White Label</a>
                <a *ngIf="currentUser?.canResetDemo" class="dropdown-item" href (click)="resetDemo()">Reset Demo</a>
                <div class="divider"></div>
              </ng-template>
              <a *ngIf="!isAdminImpersonating" class="dropdown-item" href="javascript:void(0)" (click)="signOut()">
                <i class="fas fa-sign-out-alt mr-2"></i>
                Sign out
              </a>
            </div>
          </li>
           <li *ngIf="needsToWatchTour" class="nav-item d-flex flex-row align-items-center">
            <button type="button" class="nav-link btn btn-light btn-outline-primary btn-xs px-2 ml-2" (click)="navigateToVideoTour()">
              Watch video tour
            </button>
          </li>
          <li *ngIf="!loading && !currentUser" class="navbar-text nav-item"><a class="nav-link">Not signed in</a></li>
          <li *ngIf="currentUser?.adminImpersonating" class="nav-item"><a href="/switch_back" class="nav-link">Switch Back</a><li>
        </ul>
      </div>
    </nav>
    <alert-banner *ngIf="showBanner">
      <div *ngIf="writerIsUnavailable; else setGoalsBlock">
        <em message>You've set yourself as <b>unavailable</b>. Please make yourself available to start new drafts and accept assignments. </em>
        <button class="btn btn-primary btn-sm ml-2" (click)="setAsAvailable()"><b>I'm available!</b></button>
      </div>
      <ng-template #setGoalsBlock>
        <em message>The first step to succeeding at your goals is setting them! </em>
        <button class="btn btn-primary btn-sm ml-2" [routerLink]="['/writer_dashboard', 'goals']"><b>Set my goals</b></button>
        <button type="button" class="close ml-2" id="dismiss-writer-goals-banner-button" (click)="dismissWriterGoalsBanner()">
          <span>&times;</span>
        </button>
      </ng-template>
    </alert-banner>
  `, styles: [`
    a.ap-open:hover .text-orange {
      color: #FFB471;
    }
  `]
})
export class NavBarComponent extends BaseComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Input() sidenav: ElementRef<MatSidenav> = null;
  @Input() showSidebar: boolean = true;
  @Output() bannerShown: EventEmitter<boolean> = new EventEmitter();

  loading: boolean = true
  customerId: number
  queryRef: QueryRef<Data>
  currentUser: User;
  account: Account;
  writer: Writer
  demo: boolean = environment.demo || environment.staging || !environment.production;
  navbarCollapsed: boolean = true;
  isEditspace = false;

  userExtras: ExtraPurchase['extra']['code'][] = []
  customerExtras: ExtraPurchase['extra']['code'][] = []

  constructor(
    private sessionActions: SessionActions,
    private location: Location,
    private queries: NavBarQueries,
    private router: Router,
    private route: ActivatedRoute,
    private writerProfileMutations: WriterProfileSummaryMutations,
    private editspaceService: EditspaceService
  ) {
    super()
  }

  ngOnInit(): void {
    this.queryRef = this.queries.mainQuery()
    const queryObs = this.queryRef.valueChanges
    .subscribe(({ loading, data, stale }: {loading: boolean, data: Data, stale: boolean}) => {
      if (data && data.currentUser) {
        this.loading = loading && stale
        this.currentUser = data.currentUser
        this.account = this.currentUser.role === 'customer' && this.currentUser.account
        this.writer = this.currentUser.role === 'writer' && this.currentUser.writer
        this.userExtras = (<ExtraPurchase[]>get(this.currentUser, 'extraPurchases', [])).map(ep => ep.extra.code)
        this.customerExtras = (<ExtraPurchase[]>flatten(get(this.currentUser, 'account.currentCustomers', []).map(c => c.extraPurchases))).map(ep => ep.extra.code)
        this.bannerShown.emit(this.showBanner)
        this.isEditspace = this.editspaceService.isEditspace()
      }
    })
    const paramsObs = this.route.params.subscribe(params => this.customerId = +params['customerId'])
    this.observers.push(queryObs, paramsObs)
  }

  get showWhiteLabel(): boolean {
    return this.account?.showWhiteLabel
  }

  get accountSetup(): boolean {
    return this.customerExtras.includes('account_setup')
  }

  get writerIsUnavailable(): boolean {
    return this.writer?.state === 'unavailable'
  }

  get showBanner(): boolean {
    const isWriter = !!this.writer
    const isNotInGoalsPage = !this.matchesPath("writer_dashboard/goals")
    const isUnavailable = this.writerIsUnavailable
    const hasNoGoals = !this.writer?.hasSetGoalsForThisWeek
    const canCreateWriterGoal = this.currentUser?.canCreateWriterGoal

    const dismissedAt = localStorage.getItem('writerGoalsBannerDismissedAt')
    let hasBeenDismissed = false
    if (dismissedAt && moment(dismissedAt).isAfter(moment().startOf('isoWeek'))) {
      hasBeenDismissed = true
    }

    return isWriter && (isUnavailable || canCreateWriterGoal && hasNoGoals && isNotInGoalsPage && !hasBeenDismissed)
  }

  // only show this for a week
  get needsToWatchTour(): boolean {
    const watchTourPurchase = this.currentUser && this.currentUser.extraPurchases && this.currentUser.extraPurchases.find(ep => ep.extra.code === 'video_tour')
    return watchTourPurchase && moment(watchTourPurchase.purchasedAt).isAfter(moment().subtract(1, 'week'))
  }

  get showScheduleDemoModal(): boolean {
    const currentUserId = this.currentUser && this.currentUser.id
    const modalDismissed = localStorage.getItem('scheduleDemoModalDismissed') === 'true' ||
    localStorage.getItem(`scheduleDemoModalDismissedFor${currentUserId}`) === 'true'

    return !modalDismissed
  }

  get scheduleButtonText(): string {
    if (this.accountSetup) return 'Schedule your Managed Account Setup'
  }

  get eventUrl(): string {
    if (this.accountSetup) return 'https://calendly.com/verblio-expert-account-setup-team/30-min-interview-1'
  }

  get showVerticalDivider(): boolean {
    return (!this.currentUser || this.currentUser?.canIndexHelpPage || this.currentUser?.role === 'writer' || this.isAgencySignup)
            && !this.isWhiteLabelUserInEditspace()
  }

  get isAgencySignup(): boolean {
    return this.account && this.account.agency && !this.account.setupAt
  }

  get isCustomer(): boolean {
    return this.currentUser && this.currentUser.role === 'customer'
  }

  get isWriter(): boolean {
    return this.currentUser && this.currentUser.role === 'writer'
  }

  get isWriterFrozen(): boolean {
    return this.currentUser && this.currentUser.role === 'writer' && this.currentUser.writer.state === 'suspended_as_fraud'
  }

  get isWhiteLabel(): boolean {
    return this.currentUser && this.currentUser.role === 'white_label'
  }

  get isAdminImpersonating(): boolean {
    return this.currentUser && this.currentUser.adminImpersonating
  }

  get canReadDiscussion(): boolean {
    return this.isWriter && this.currentUser.writer.canReadDiscussion
  }

  get canEditProfile(): boolean {
    return this.isWriter && this.currentUser.writer.canEditProfile
  }

  get canReadJobs(): boolean {
    return this.isWriter && ['pending_review', 'monitored', 'active', 'unavailable'].includes(this.writer.state)
  }

  get canCreateTopics(): boolean {
    return this.isWriter && ['pending_review', 'monitored', 'active', 'unavailable'].includes(this.writer.state)
  }

  get canReadInvoices(): boolean {
    return this.isWriter && ['pending_review', 'monitored', 'active', 'unavailable', 'suspended', 'deactivated'].includes(this.writer.state)
  }

  get shouldShowHomeLink(): boolean {
    return ['pending_review', 'monitored', 'active', 'unavailable'].includes(this.writer.state)
  }

  // Until wl has more options other than "Sign out"
  get showDropdownMenu(): boolean {
    const invalidWriterStates = ['suspended_as_fraud', 'deactived']
    return this.currentUser?.role === 'customer' || (this.currentUser?.role === 'writer' && (invalidWriterStates.indexOf(this.currentUser.writer.state) === -1))
  }

  get showMobileSidebarButton (): boolean {
    return this.showSidebar && this.isMobile
  }

  setAsAvailable(): void {
    this.writerProfileMutations.toggleWriterUnavailableState(false)
  }

  shouldShowSubmenu(item: string): boolean {
    if (item === 'user_preferences' || item === 'account_preferences' || item === 'profile_info') {
      return !['suspended', 'deactivated', 'rejected'].includes(this.writer.state)
    }
    return true
  }

  signOut(): void {
    this.sessionActions.signOut()
  }

  resetDemo(): boolean {
    if (this.demo) {
      if (confirm('Are you sure you want to reset all data for this account?')) {
        location.assign(`/demo_setup/setup`)
      }
    }
    return false
  }

  linkTo(path: string, id: number | string = null): string {
    return externalRoute(path, id)
  }

  matchesPaths(paths: string[]): boolean {
    for (let i in paths) {
      if (this.matchesPath(paths[i])) return true
    }
    return false
  }

  matchesPath(path: string): boolean {
    const currentPath = this.location.path()
    return currentPath.includes(path)
  }

  navigateToUrl(url: string): void {
    this.router.navigateByUrl(url)
  }

  // scheduling a demo
  onDemoScheduled(): void {
    this.toggleScheduleDemoDismissed(true)
    this.queryRef.refetch()
  }

  toggleScheduleDemoDismissed(val: boolean): void {
    localStorage.setItem(`scheduleDemoModalDismissedFor${get(this.currentUser, 'id')}`, val.toString())
  }

  isEditspaceOld(): boolean {
    return window.location.hostname.includes("editspace") || true
  }

  isWhiteLabelUserInEditspace(): boolean {
    return this.isEditspace && this.isWhiteLabel
  }

  dismissWriterGoalsBanner(): void {
    localStorage.setItem('writerGoalsBannerDismissedAt', moment().format())
  }

  navigateToVideoTour(): void {
    window.open("https://help.verblio.com/en/articles/5989726-your-verblio-guided-tour", "_blank")
  }
}
